<template>
    <div class="v-short-key d-inline-flex text-nowrap text-muted py-25 px-50 g-25 border rounded align-items-center">
        <template v-for="(c,i) in combination">
            <template v-if="c == 'CTRL'">
                <template v-if="isMac">
                    <feather-icon :key="i" icon="CommandIcon"></feather-icon>
                </template>
                <template v-else>
                    CTRL
                </template>
            </template>
            <template v-else>
                {{ c }}
            </template>
        </template>
    </div>
</template>

<script>
export default {
    props:{
        combination:{
            type:Array,
            default:()=>([])
        }
    },
    methods:{
        
    },
    computed:{
        isMac(){
            return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
        }
    }
}
</script>

<style>
.v-short-key{
    font-size: 0.85rem
}
</style>